import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const updateUserSystemFormat: UseCase<AuthRepository, 'updateSystemFormat'> = repository => {
  return async systemFormat => {
    await repository.updateSystemFormat(systemFormat)
  }
}
